import Breadcrumb from "components/common/Breadcrumb/Breadcrumb";
import DateRangePickerNew from "components/common/DateRangePicker/DateRangePickerNew";
import Header from "components/common/Header/Header";
import SelectOption from "components/common/Select/Select";
import SideBarNew from "components/common/SideBar/SideBarNew";
import {
  REPORTING_BREADCRUMB,
  REPORTING_BREADCRUMB_PAGES,
} from "Constants/BreadcrumbConstant";
import { LoginContext } from "helpers/LoginContext";
import React, { useContext, useEffect, useState } from "react";


import PaginationComponent from "components/common/Pagination/index";
import {
  DOC_DOWNLOAD_URL,
  emptyPaginationObj,
  REPORTING_LIMIT,
  SORT_TYPE,
} from "Constants/constant";
import CircularLoader from "components/common/CircularLoader/CircularLoader";
import TableHeader from "components/common/Table/TableHeader";
import { apiPostRequest } from "helpers/Requests";
import { URL_REPORTING_FEEDBACK_REPORTS } from "store/services/URL";

import moment from "moment";

import { toast } from "react-toastify";

import {
  addMonths,
  exportTOExcel,
  truncateTextReporting,
} from "Utils/utils";
import useReportExport from "../useReportExport";
import {
  ReportFilterActions,
  ReportFilterField,
  ReportFilterGrid,
  ReportFilterSearchField,
  ReportFiltersShell,
  ReportPageContent,
  ReportTableSection,
} from "../reportFilterUi";
import { withReportSortOnUrl } from "../reportExportUtils";
import PopoverContainer from "components/common/Popover/PopoverContainer";

const ComplaintsReports = () => {
  const { sideBarPadding, isUserGracePeriodOver } = useContext(LoginContext);

  const [search, setSearch] = useState(null);

  const [reportList, setReports] = useState(null);
  const [loader, setLoader] = useState(false);
  const [paginationObj, setPaginationObj] = useState(emptyPaginationObj);
  const [page, setPage] = useState(1);
  const [sortDescending, setSortDescending] = useState(
    paginationObj.sort_order === SORT_TYPE.DESC ? true : false
  );
  const [sortBy, setSortBy] = useState(paginationObj.sort_field);

  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  const [status, setStatus] = useState(null);
  const [selectedFromDate, setSelectedFromDate] = useState(null);
  const STATUS = [
    {
      label: "All",
      value: "all",
    },
    {
      label: "Completed",
      value: "completed",
    },
    {
      label: "In Progress",
      value: "in_progress",
    },
    {
      label: "Pending",
      value: "pending",
    },
  ];

  const [isInitialRender, setIsInitialRender] = useState(true);
  const { runExport, QueuedModal, getExportSortFilters } = useReportExport(
    "complaint_report",
    "Complaint Report",
    { sortBy, sortDescending }
  );
  const [isDisableSearch, setIsDisableSearch] = useState(false);
  useEffect(() => {
    if (isInitialRender) {
      setIsInitialRender(false);
      return;
    }

    fetchListReports();
  }, [page]);

  const fetchListReports = async (
    isClearAll = false,
    report = null,
    filters = null
  ) => {
    if (!fromDate && !toDate) {
      toast("Select create date range to get data");
      return;
    }

    setLoader(true);
    let url = `${URL_REPORTING_FEEDBACK_REPORTS}?per_page=25&page=${page}`;
    url = withReportSortOnUrl(url, filters || {}, sortBy, sortDescending);
    const payload = {
      search: search ? search : "",
      status: isClearAll ? "all" : status ? status?.value : "all",
      date_range: isClearAll
        ? "all"
        : toDate && fromDate
        ? [fromDate, toDate]
        : "all",
      type: "complaint",
    };
    if (report) {
      await runExport({
        format: report,
        payload,
        syncUrl: url,
        filters: filters || {},
        totalRows: paginationObj?.total,
        setLoader,
        onSyncExcel: exportTOExcelFile,
        onSyncPdf: (downloadUrl) => window.open(downloadUrl, "_blank"),
      });
      return;
    }
    await apiPostRequest(url, payload)
      .then((res) => {
        if (res.status === 200) {
          setLoader(false);
          setReports(res?.data?.data);
          setPaginationObj((prev) => ({
            ...prev,
            total: res?.data?.data?.feedbackAndComplaints?.total,
            totalPages: Math.ceil(
              res?.data?.data?.feedbackAndComplaints?.total /
                res?.data?.data?.feedbackAndComplaints?.per_page
            ),
          }));
        }
      })
      .catch((error) => {
        console.log({ error });
        setLoader(false);
      });
  };
  const handleFileDownLoad = (e) => {
    fetchListReports(false, e, getExportSortFilters());

    // if (e === "xlsx") {
    //   exportTOExcelFile();
    // } else {
    //   fetchListReports(false, e);
    // }
  };

  const handleSearch = () => fetchListReports(false);

  const handleClearFilters = () => {
    setSearch(null);
    setReports([]);
    setStatus(null);
    setFromDate(null);
    setToDate(null);
    setSelectedFromDate(null);
  };

  const exportTOExcelFile = (reportData) => {
    const transformedData =
      reportData &&
      reportData.feedbackAndComplaints &&
      reportData?.feedbackAndComplaints?.map((item) => {
        return {
          Name: item?.name,
          Date_of_Complaint: moment(item?.date).format("DD/MM/YYYY"),
          Subject: item?.subject,
          Detail: item?.details,
          Status: item?.status,
        };
      });
    if (
      !transformedData ||
      transformedData === undefined ||
      transformedData?.length === 0
    ) {
      toast("No data found!");
      return;
    }

    exportTOExcel(transformedData);
  };

  const handleFetch = (obj) => {
    fetchListReports(false, null, { ...obj });
  };

  const flipSort = (by) => {
    setSortBy(by);
    setSortDescending(!sortDescending);
    handleFetch({
      sort_field: by,
      sort_order: !sortDescending ? SORT_TYPE.DESC : SORT_TYPE.ASC,
    });
  };

  return (
    <div className='min-h-full'>
      <SideBarNew />
      <div
        className={`${
          sideBarPadding ? "lg:pl-[4rem] duration-300" : "lg:pl-64 duration-300"
        }  flex flex-col `}
      >
        <main className='flex-1 bg-gray-50 min-h-screen'>
          <Header
            title='Complaint  Reports'
            breadcrumb={
              <Breadcrumb
                pages={REPORTING_BREADCRUMB(
                  REPORTING_BREADCRUMB_PAGES.COMPLAINTS_REPORTS
                )}
              />
            }
          />
          <ReportPageContent>
            <ReportFiltersShell>
              <ReportFilterGrid columns={4}>
                <ReportFilterField label='Status'>
                  <SelectOption
                    newDesign
                    cssClass='w-full'
                    name='primary_disability'
                    isSearch={true}
                    data={STATUS || []}
                    selectedOption={status}
                    handleChange={(e) => setStatus(e)}
                  />
                </ReportFilterField>
                <ReportFilterField label='Date Range of Complaints (Max 3 Months)' required>
                  <DateRangePickerNew
                    handleCancel={() => {
                      setFromDate(null);
                      setToDate(null);
                      setReports([]);
                    }}
                    handleChange={(obj) => {
                      if (obj) {
                        obj.fromDate && setFromDate(obj.fromDate);
                        obj.toDate && setToDate(obj.toDate);
                      }
                    }}
                    setSelectedFromDate={setSelectedFromDate}
                    fromDate={fromDate}
                    toDate={toDate}
                    maxDate={addMonths(selectedFromDate, 3)}
                    setIsDisableSearch={setIsDisableSearch}
                  />
                </ReportFilterField>
                <ReportFilterSearchField
                  label='Search by name'
                  search={search}
                  setSearch={setSearch}
                  onSearch={handleSearch}
                  placeholder='Search by name'
                />
              </ReportFilterGrid>
              <ReportFilterActions
                onSearch={handleSearch}
                onClear={handleClearFilters}
                onExport={handleFileDownLoad}
                isLoading={loader}
                isSearchDisabled={isDisableSearch}
                isUserGracePeriodOver={isUserGracePeriodOver}
              />
            </ReportFiltersShell>
            <ReportTableSection>
                <table className='border min-w-full divide-y divide-gray-300'>
                  <thead
                    // style={{ top: "130px" }}
                    className='bg-gray-50 sticky z-[5]'
                  >
                    <tr>
                      <TableHeader
                        sortName='name'
                        flipSort={flipSort}
                        sortBy={sortBy}
                        sortDescending={sortDescending}
                        label={"Name"}
                        cssClass='bg-blue-50 pl-4'
                      />

                      <TableHeader
                        sortName='date'
                        flipSort={flipSort}
                        sortBy={sortBy}
                        sortDescending={sortDescending}
                        label={"Date of Complaint"}
                        cssClass='bg-blue-50'
                      />

                      <TableHeader
                        sortName='subject'
                        flipSort={flipSort}
                        sortBy={sortBy}
                        sortDescending={sortDescending}
                        label={"Subject"}
                        cssClass='bg-blue-50'
                      />

                      <TableHeader
                        sortName='detail'
                        flipSort={flipSort}
                        sortBy={sortBy}
                        sortDescending={sortDescending}
                        label={"Details"}
                        cssClass='bg-blue-50'
                      />

                      <TableHeader isSort={false} label={"Status"} cssClass='bg-blue-50 px-0' />
                    </tr>
                  </thead>
                  <tbody className='divide-y divide-gray-200 bg-white overflow-y-auto'>
                    {loader ? (
                      <tr className='bg-white'>
                        <td colSpan={5} className='py-6 text-center bg-white'>
                          <div
                            className={`flex flex-col w-full min-h-screen  items-center justify-start`}
                          >
                            <CircularLoader
                              classes='flex justify-center items-center'
                              classloader='loader-l'
                            />
                          </div>
                        </td>
                      </tr>
                    ) : reportList !== null &&
                      reportList?.feedbackAndComplaints?.data?.length > 0 ? (
                      reportList?.feedbackAndComplaints?.data?.map(
                        (singleFeedback, index) => (
                          <tr
                            key={index}
                            className='even:bg-white odd:bg-gray-50'
                          >
                            <td className='whitespace-nowrap py-4 text-sm'>
                              <div className='flex items-center'>
                                <div className='capitalize'>
                                  <span title={`${singleFeedback.name} `}>
                                    <p
                                      className={`w-40 truncate cursor-pointer pl-2`}
                                    >{`${singleFeedback.name}`}</p>
                                  </span>
                                </div>
                              </div>
                            </td>

                            <td className='whitespace-nowrap px-3 text-left py-4 text-sm text-gray-500'>
                              {singleFeedback?.date
                                ? moment(singleFeedback?.date).format(
                                    "DD/MM/YYYY"
                                  )
                                : "-"}
                            </td>
                            <td className='whitespace-nowrap px-3 text-left py-4 text-sm text-gray-500'>
                              {/* {singleFeedback?.subject || "-"} */}
                              <div
                                className=' font-medium whitespace-nowrap overflow-hidden text-gray-900 capitalize'
                                style={{
                                  maxWidth: "140px",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {singleFeedback?.subject ? (
                                  <PopoverContainer
                                    cssClass={`text-white text-sm bg-gradient p-2 rounded-md z-10`}
                                    itemComponent={() => {}}
                                    toolTip={`${singleFeedback?.subject}`}
                                  >
                                    <span>
                                      {truncateTextReporting(
                                        singleFeedback?.subject
                                      )}
                                    </span>
                                  </PopoverContainer>
                                ) : (
                                  "-"
                                )}
                              </div>
                            </td>
                            <td className='whitespace-nowrap px-3 text-left py-4 text-sm text-gray-500'>
                              {/* {singleFeedback?.details || "-"} */}
                              <div
                                className=' font-medium whitespace-nowrap overflow-hidden text-gray-900 capitalize'
                                style={{
                                  maxWidth: "140px",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {singleFeedback?.details ? (
                                  <PopoverContainer
                                    cssClass={`text-white text-sm bg-gradient p-2 rounded-md z-10`}
                                    itemComponent={() => {}}
                                    toolTip={`${singleFeedback?.details}`}
                                  >
                                    <span>
                                      {truncateTextReporting(
                                        singleFeedback?.details
                                      )}
                                    </span>
                                  </PopoverContainer>
                                ) : (
                                  "-"
                                )}
                              </div>
                            </td>
                            <td className='whitespace-nowrap px-3 text-left py-4 text-sm text-gray-500 capitalize'>
                              {singleFeedback?.status || "-"}
                            </td>
                          </tr>
                        )
                      )
                    ) : (
                      <tr>
                        <td
                          colSpan={5}
                          className='py-6 text-center text-red-600'
                        >
                          No data found. Please adjust your filters to get
                          relevant results
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
            </ReportTableSection>
              {reportList &&
                reportList?.feedbackAndComplaints?.data?.length > 0 && (
                  <div className='mt-3'>
                    <PaginationComponent
                      page={paginationObj?.page || 1}
                      activeListLength={
                        reportList?.feedbackAndComplaints?.data || []
                      }
                      limit={REPORTING_LIMIT}
                      totalList={paginationObj?.total}
                      handlePagination={(e) => {
                        setPage(e);
                        const obj = paginationObj;
                        obj.page = e;
                        setPaginationObj({ ...obj });
                      }}
                      totalPages={paginationObj?.totalPages}
                    />
                  </div>
                )}
          </ReportPageContent>
        </main>
      </div>
      <QueuedModal />
    </div>
  );
};

export default ComplaintsReports;
